import { useActionState, useState } from "react"
import { RegisterStateDiscovered } from "../actions/register"
import { DarkText } from "@ui/text"
import { Description, ErrorMessage, Field, Fieldset, Label } from "@ui/fieldset"
import { Radio, RadioField, RadioGroup } from "@ui/radio"
import { continueAction } from "../actions/continue"
import { Button } from "../../../../themes/catalyst/button"
import { CheckInbox } from "./CheckInbox"

interface Props {
    formState: RegisterStateDiscovered
}

export function DiscoveredOrganizations({ formState: parentState }: Props) {
    const [formState, formAction, pending] = useActionState(continueAction, {
        status: "fresh",
    })
    const [selectedValue, setSelectedValue] = useState<string | undefined>(undefined)
    const action = selectedValue === "none" ? "create" : "requestToJoin"

    if (formState.status === "created") {
        return <CheckInbox label="Please check your inbox for an invite email." />
    }

    if (formState.status === "invitation-requested") {
        return <CheckInbox label="Invitation requested. If you can, ask your colleagues to check their inbox." />
    }

    return (
        <div>
            <DarkText>We think your company already has an account with us. Please select your organization:</DarkText>
            <form action={formAction}>
                <input type="hidden" name="action" value={action} />
                <input type="hidden" name="email" value={parentState.data.email} />
                <input type="hidden" name="full_name" value={parentState.data.fullName} />
                <input type="hidden" name="company_name" value={parentState.data.companyName} />
                <input type="hidden" name="country" value={parentState.data.country} />
                <input type="hidden" name="account_type" value={parentState.data.accountType} />
                <Fieldset>
                    <RadioGroup name="organization_id" onChange={setSelectedValue}>
                        {parentState.organizations.map((org) => (
                            <RadioField key={org.id}>
                                <Radio value={org.id} color="primary" />
                                <Label>{org.displayName}</Label>
                                <Description>{org.discoverySettings.emailDomains.join(", ")}</Description>
                            </RadioField>
                        ))}
                        <RadioField>
                            <Radio value="none" color="teal" />
                            {parentState.organizations.length > 1 ? (
                                <Label>None of these match</Label>
                            ) : (
                                <Label>This isn't my organization</Label>
                            )}
                            <Description>I’d like to continue with registration and create a new account</Description>
                        </RadioField>
                    </RadioGroup>
                </Fieldset>
                {selectedValue !== undefined && (
                    <Button type="submit" color="primary" className="mt-8 w-full" disabled={pending}>
                        {pending ? "Loading..." : selectedValue === "none" ? "Continue" : "Request to join"}
                    </Button>
                )}
                {formState.status === "error" && Array.isArray(formState.errors?.general) && (
                    <>
                        {formState.errors.general.map((error) => (
                            <Field>
                                <ErrorMessage key={error}>{error}</ErrorMessage>
                            </Field>
                        ))}
                    </>
                )}
            </form>
        </div>
    )
}
